// extracted by mini-css-extract-plugin
export default {"containerSlider":"slider_containerSlider__Z1I7Y","nextArrow":"slider_nextArrow__rTuVG","prevArrow":"slider_prevArrow__KK9kJ","slideCountDisplay":"slider_slideCountDisplay__0tdkM"};